import React, {useEffect} from 'react';
import {BrowserRouter} from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import {QueryClient, QueryClientProvider} from 'react-query';

import {Environment} from 'shared/Env';

import {AppRoutes} from './routes';
import {
  AlertComponent,
  ConfirmationDialogComponent,
  SplashScreen,
} from './shared/components';
import {Layout} from 'shared/layouts/Layout';
import {ThemesProvider, TitleProvider, UserProvider} from './shared/contexts';

const queryClient = new QueryClient();

export const App = () => {
  useEffect(() => {
    const script = document.createElement('script');
    const scriptFeedBack = document.createElement('script');
    script.type = 'module';
    script.src = `${Environment.URL_WC_FEEDABACK}`;
    script.crossOrigin = 'anonymous';

    document.body.appendChild(script);
    document.body.appendChild(scriptFeedBack);

    if (Environment.CLARITY_PROJECT_ID) {
      const clarityScript = document.createElement('script');
      clarityScript.type = 'text/javascript';
      clarityScript.innerHTML = `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${Environment.CLARITY_PROJECT_ID}");
      `;

      document.head.appendChild(clarityScript);
    }

    return () => {
      document.body.removeChild(script);
      document.body.appendChild(scriptFeedBack);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <CssBaseline />
      <ThemesProvider>
        <UserProvider>
          <SplashScreen>
            <BrowserRouter>
              <TitleProvider>
                <Layout>
                  <AppRoutes />
                  <AlertComponent />
                  <ConfirmationDialogComponent />
                </Layout>
              </TitleProvider>
            </BrowserRouter>
          </SplashScreen>
        </UserProvider>
      </ThemesProvider>
    </QueryClientProvider>
  );
};
